import { render, staticRenderFns } from "./StatisticsGone.vue?vue&type=template&id=23f476bf"
import script from "./StatisticsGone.vue?vue&type=script&lang=js"
export * from "./StatisticsGone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports